import React from 'react';

const FooterItem = ({ children, color = '#1565c0', backgroundColor = '#e3f2fd', style = {} }) => {
  return (
    <div
      style={{
        textAlign: 'start',
        fontWeight: 700,
        color,
        backgroundColor,
        borderRadius: 8,
        padding: '6px 12px',
        fontSize: '1em',
        letterSpacing: '0.2px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default FooterItem;
